/*
* <license header>
*/

import React from 'react'
import { Heading, Text, View } from '@adobe/react-spectrum'
import { useNavigate } from 'react-router-dom'
import { APP_TYPES } from '../../data/constants'

const FEATURED = [
  {
    title: APP_TYPES[0].title,
    description: APP_TYPES[0].description,
    path: '/wizard?type=generator-app-asset-compute'
  },
  {
    title: APP_TYPES[2].title,
    description: APP_TYPES[2].description,
    path: '/wizard?type=generator-app-api-mesh'
  },
  {
    title: APP_TYPES[7].title,
    description: APP_TYPES[7].description,
    path: '/wizard?type=workfront-ui-ext-tpl'
  },
  {
    title: APP_TYPES[12].title,
    description: APP_TYPES[12].description,
    path: '/wizard?type=generator-app-remote-mcp-server-generic'
  }
]

const CARD_STYLE = {
  border: '1px solid var(--card-border)',
  borderRadius: '8px',
  padding: '1.5rem',
  backgroundColor: 'var(--white)',
  cursor: 'pointer',
  transition: 'box-shadow 0.2s ease'
}

export const FeaturedContentSection = () => {
  const navigate = useNavigate()

  return (
    <View marginBottom="size-600">
      <Heading level={2} UNSAFE_style={{ margin: 0, marginBottom: '1.25rem', fontSize: '1.25rem', fontWeight: 700 }}>
        Featured Content
      </Heading>
      <div className="FeaturedContent-grid">
        {FEATURED.map(({ title, description, path }) => (
          <View
            key={title}
            UNSAFE_style={CARD_STYLE}
            onClick={() => navigate(path)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && navigate(path)}
          >
            <Heading
              level={3}
              UNSAFE_style={{
                margin: 0,
                marginBottom: '0.625rem',
                fontSize: '1rem',
                fontWeight: 600,
                color: '#2196f3',
                textDecoration: 'none'
              }}
            >
              {title}
            </Heading>
            <Text UNSAFE_style={{ color: 'var(--gray-600)', fontSize: '0.875rem', lineHeight: 1.5 }}>
              {description}
            </Text>
          </View>
        ))}
      </div>
    </View>
  )
}
